export default {
    getGroupIdentifiers: { method: 'get', url: 'groups/identifiers' },
    postGroupIdentifiers: { method: 'post', url: 'groups/identifiers' },
    updateGroupIdentifiers: { method: 'put', url: 'groups/identifiers/{id}' },
    deleteGroupIdentifiers: { method: 'delete', url: 'groups/identifiers/{id}' },
}
